import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import colors from "../theme/Colours";

const StyledDialogTitle = styled(DialogTitle)({});

const StyledTitleText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.h3.fontSize,
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  maxHeight: 480,
  overflowY: "auto",
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(1),
}));

const StyledActionStack = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(3),
}));

const ConfirmButton = styled(Button)(({ theme }) => ({
  backgroundColor: colors.primaryButtonOrange,
  borderRadius: theme.shape.borderRadius,
  "&:hover": {
    backgroundColor: colors.primaryButtonOrangeHover,
  },
}));

const CancelButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${colors.cancelRed}`,
  color: colors.cancelRed,
}));

export default function CommonDialog({
  content,
  isOpen,
  title,
  showCloseButton = false,
  closeHandler,
  confirmHandler,
}: {
  content: React.ReactNode;
  isOpen: boolean;
  showCloseButton?: boolean;
  title: string;
  closeHandler: () => void;
  confirmHandler: () => void;
}) {
  return (
    <Dialog fullWidth maxWidth="sm" open={isOpen} onClose={closeHandler}>
      <StyledDialogTitle display="flex" justifyContent="space-between">
        <StyledTitleText variant="h6">{title}</StyledTitleText>
        {showCloseButton && (
          <Box>
            <IconButton onClick={closeHandler} size="large">
              <CloseIcon />
            </IconButton>
          </Box>
        )}
      </StyledDialogTitle>
      <StyledDialogContent>{content}</StyledDialogContent>
      <StyledActionStack
        spacing={2}
        direction="row"
        justifyContent="space-between"
      >
        <ConfirmButton
          variant="contained"
          color="primary"
          onClick={confirmHandler}
        >
          Confirm
        </ConfirmButton>
        <CancelButton variant="outlined" onClick={closeHandler}>
          Cancel
        </CancelButton>
      </StyledActionStack>
    </Dialog>
  );
}
